import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "@mui/material";
import { productionOrderActions } from "../../../../../../actions";
import DataTable from "../../../../../common/ui/table/DataTable/DataTable.component";

const ProductionOrders = (props) => {
  const { searchQuery } = props;
  const dispatch = useDispatch();
  const productionOrders = useSelector((state) => state.productionOrders);

  const columns = [
    { field: "id", headerName: "ID", width: 70 },

    {
      field: "name",
      headerName: "Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "chinese_name",
      headerName: "Chinese Name",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 200,
      flex: 1,
    },
    {
      field: "created_at",
      headerName: "Created At",
      width: 150,
      hide: true,
    },
    {
      field: "updated_at",
      headerName: "Updated At",
      width: 150,
      hide: true,
    },
  ];

  const recordIdentifier = "name";

  useEffect(() => {
    dispatch(productionOrderActions.getAllParameters());
  }, [dispatch]);

  return (
    <Box>
      {productionOrders && (
        <DataTable
          loading={productionOrders?.loading}
          rows={productionOrders?.items?.data}
          columns={columns}
          recordIdentifier={recordIdentifier}
          actionIdentifier="productionOrderActions"
          isEnabledView={true}
          isEnabledEdit={true}
          isEnabledDelete={true}
          search ={searchQuery}
        />
      )}
    </Box>
  );
};

export default ProductionOrders;
